var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.444 2.4h-.777V1H11.11v1.4H4.89V1H3.333v1.4h-.777C1.692 2.4 1 3.03 1 3.8v9.8c0 .77.692 1.4 1.556 1.4h10.888C14.3 15 15 14.37 15 13.6V3.8c0-.77-.7-1.4-1.556-1.4zm0 11.2H2.556v-7h10.888v7zm0-8.4H2.556V3.8h10.888v1.4zM4.111 8H8v3.5H4.111V8z",
    fill: "#000"
  })));
}
export default SvgEvent;